/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Operational_Section1 from "./sections/Operational_Section1";

function Operational() {
  usePageMeta({
    title: "Operational Policy | Spechs Ireland",
    description:
      "Spechs operational policy — how we deliver reliable, consistent service across all our operations in Ireland.",
    canonical: "https://www.spechs.ie/operational/",
  });
  return (
    <SubPageLayout title="Operational Roles & Responsibilities">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Operational_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default Operational;
